import React from "react";
import { EyeOff } from "lucide-react";

/**
 * Bandeau d'une campagne en BROUILLON : la page s'affiche (le rav vérifie
 * son rendu avant de la partager) mais aucun don n'est possible — le
 * serveur le refuse de toute façon. Le formulaire reste visible, bouton
 * désactivé, pour que l'aperçu soit fidèle.
 */
export default function BandeauApercu() {
  return (
    <div role="status" data-testid="bandeau-apercu"
      className="mb-6 flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3.5">
      <EyeOff className="h-4 w-4 mt-0.5 shrink-0 text-amber-600" />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-amber-900">Aperçu : campagne pas encore publiée</p>
        <p className="text-xs text-amber-800 mt-0.5 leading-relaxed">
          Les dons seront ouverts dès que la synagogue l'aura publiée.
        </p>
      </div>
    </div>
  );
}
